import { helpers } from '@vuelidate/validators'


// vuelidate minLength counts empty string valid (wat?!) => https://github.com/monterail/vuelidate/blob/master/src/validators/minLength.js
const minLength = (n) => helpers.withParams({ type: 'minLength', n, message: n + '+ characters' }, v => String(v).length >= n)

export default minLength
